import { TypedUseSelectorHook, useDispatch as useReduxDispatch, useSelector as useReduxSelector } from 'react-redux';

import { AppDispatch, RootState } from '../config';
import { IError } from '../interfaces';

export const useDispatch: () => AppDispatch = useReduxDispatch;
export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

export const convertToError = (e: unknown): IError => ({
  error: (e as Error).message,
});
